export default __webpack_public_path__ + "static/media/partnership-bg.29a7f08b.png";